import styled, { css, keyframes } from 'styled-components';

import { Filters } from '../newDashboardStyles';
import { statusTextColor } from '../../../utils/constants/statusMonitoring';

const fontSizes = {
  extra_small: '11px',
  small: '13px',
  medium: '15px',
  large: '18px',
  extra_large: '23px',
  responsive: {
    small: '11px',
    medium: '12px',
    extra_large: '21px',
  }
};

const colors = {
  ivory_pale: '#fcf7f6',
  snowy_white: '#f6f6f6',
  white: '#fff',
  purple: '#9c179e',
  charcoal_gray: '#484848',
  sky_blue: '#41b8d5',
  sunflower_yellow: '#fce83a',
  olive_green: '#c8e066',
  black: '#000',
  light_gray: '#c9c7d0',
};

const fontFamilies = {
  oswald: 'Oswald',
  lato: 'Lato',
};

const applyEllipsis = (lines) => css`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${lines};
  word-break: break-word;
  overflow: hidden;
`;

const fadeInPage = keyframes`
  0% {
    opacity: 0;
    transform: translateY(10px) scale(0.99);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const Container = styled.div`
  height: 100vh;
  width: 95%;
  margin-left: 5%;
  padding: 1.5%;
  background: ${colors.ivory_pale};
  display: flex;
  flex-direction: column;
  gap: 2%;
  scrollbar-width: none;

  & > * {
    animation: ${fadeInPage} 0.4s ease-out forwards;
  }

  @media (max-width: 425px) {
    margin-left: 0;
    width: 100%;
    margin-top: 85px;
    height: calc(100vh - 85px);
  }
  @media (max-width: 980px) {
    overflow-y: auto;
  }
`;

export const Header = styled.div`
  padding: 2%;
  border-radius: 24px;
  background: ${colors.white};
  display: flex;
  flex-direction: column;
  h1 {
    font-size: ${fontSizes.extra_large};
    font-family: ${fontFamilies.oswald}, sans-serif;
    text-transform: uppercase;
  }
  @media (max-width: 980px) {
    h1 {
      font-size: ${fontSizes.responsive.extra_large};
    }
  }
  .ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
    max-width: 180px;
  }
  .ant-select-selection--multiple .ant-select-selection__placeholder {
    margin-top: -10px;
  }
  .ant-select-allow-clear .ant-select-selection--multiple .ant-select-selection__rendered, .ant-select-show-arrow .ant-select-selection--multiple .ant-select-selection__rendered {
    height: 30px;
    overflow: auto;
    scrollbar-width: none;
  }
  * {
    font-family: ui-sans-serif, system-ui, "sans serif";
  }
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const Title = styled.h1`
  font-size: 30px;
  font-weight: 300;
  color: #374151;
  font-family: 'Oswald', sans-serif;
  margin: 0;
`;

export const NewBatchButtonWrapper = styled.div`
  position: relative;
`;

export const NewBatchButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  background: linear-gradient(to right, #ffeb3b, #fdd835);
  color: #111827;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  font-weight: 500;
  font-size: 0.875rem;
  border: none;
  cursor: pointer;

  .plus-icon {
    font-size: 14px;
    stroke: #000000;
    stroke-width: 20;
  }
  
  .button-text {
    font-weight: bold;
  }
  
  svg.lucide.lucide-chevron-down-icon.lucide-chevron-down {
    transition: transform 0.3s;
    transform: ${props => props.open ? 'rotate(180deg)' : 'rotate(0)'};
  }

  
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border: 1px solid #e5e7eb;
  overflow: hidden;
  z-index: 10;
  width: 256px;
`;

export const DropdownItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${props => props.variant === 'hybrid' ? 'rgba(146, 123, 248, 0.1)' : 'rgba(239, 246, 255, 1)'};
  }
`;

export const WrapperIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: ${props => props.bgColor || 'rgba(146, 123, 248, 0.2)'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  svg.lucide.lucide-file-stack-icon.lucide-file-stack {
    color: #0092b8;
    width: 16px;
  }
  
  ${DropdownItem}:hover & {
    background-color: ${props => props.hoverBg || 'rgba(146, 123, 248, 0.3)'};
  }
`;

export const DropdownItemContent = styled.div`
  flex: 1;
`;

export const DropdownItemTitle = styled.div`
  font-weight: 600;
  color: #374151;
  font-size: 14px;
`;

export const DropdownItemSubtitle = styled.div`
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
`;

export const Divider = styled.div`
  border-top: 1px solid #f3f4f6;
`;


export const Content = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  gap: 2%;
  overflow: hidden;
  @media (max-width: 980px) {
    flex-direction: column;
    overflow: visible;
  }
`;

export const Sidebar = styled.div`
  height: 100%;
  width: 25%;
  flex-shrink: 0;
  padding: 12px;
  border-radius: 24px;
  background: ${colors.white};
  color: ${colors.black};
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  .pagination-wrapper {
    margin-top: auto;
    height: ${props => props.pageNumberHeight}px;
    display: grid;
    place-items: center;
    .ant-pagination-item {
      font-family: ${fontFamilies.lato}, sans-serif;
      a {
        text-decoration: none;
      }
    }
    .ant-pagination-item-active {
      border-color: ${colors.sky_blue};
      a {
        color: ${colors.sky_blue};
      }
    }
  }
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 980px) {
    height: auto;
    width: 100%;
  }
`;

const batchItemLeftAnimation = keyframes`
  0% {
    opacity: 0;
    left: -100px;
  }
  100% {
    opacity: 1;
    left: 0px;
  }
`;

const batchItemAnimation = keyframes`
  0% {
    opacity: 0;
    top: 100px;
    // transform: scale(0);
  }
  100% {
    opacity: 1;
    top: 0px;
    // transform: scale(1);
  }
`;

export const BatchItem = styled.div`
  min-height: 98px;
  padding: 12px;
  border-radius: 12px;
  font-family: ${fontFamilies.lato}, sans-serif;
  background: ${props => (props.active ? colors.purple : colors.snowy_white)};
  color: ${props => props.active && colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  gap: 6px;
  /*transform: scale(1);
  transition: transform 0.1s linear;*/
  transition: background 0.5s ease-in-out;
  :hover {
    cursor: pointer;
  }
  &.animate {
    position: relative;
    opacity: 0;
    // transform-origin: 0 0;
    animation: ${batchItemAnimation} 0.5s ease-in-out;
    animation-delay: ${props => `${props.index === 0 ? 0 : props.index * 0.3}s`};
    animation-fill-mode: forwards;
  }
  &.clicking {
    transform: scale(0.98);
  }
  p {
    min-width: 85px;
    font-size: ${fontSizes.extra_small};
    color: ${props => props.active ? '#dcdcdc' : '#7f7f7f'};
  }
  .batch-title {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 6px;
    h6 {
      font-size: ${fontSizes.medium};
      font-weight: 700;
      color: ${props => props.active && colors.white};
      ${applyEllipsis(2)}
    }
    strong {
      color: ${colors.black};
    }
  }
  .progress-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: ${fontSizes.small};
    @media (max-width: 1180px) {
      width: 84%;
    }
  }
  .batch-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
  }
  @media (max-width: 980px) {
    .batch-title {
      p {
        font-size: ${fontSizes.responsive.small};
      }
  }
`;

export const ProgressBar = styled.div`
  height: 8px;
  width: 150px;
  background: ${colors.charcoal_gray};
  border-radius: 12px;
  overflow: hidden;
  @media (max-width: 1180px) {
    min-width: 70%;
  }
  @media (max-width: 980px) {
    min-width: 100%;
  }
  div {
    height: 8px;
    width: ${props => (props.value ? props.value : 0)}%;
    background: ${colors.sky_blue};
    border-radius: 12px;
    transition: all 1s ease-in;
  }
`;

const arrowAnimation = keyframes`
  0% {
    opacity: 0;
    marker-end: none;
    stroke-dashoffset: 250;
  }
  100% {
    opacity: 1;
    marker-end: '';
    stroke-dashoffset: 0;
  }
`;

const popInAnim = keyframes`
  100% {
    transform: scale(1);
  }
`;
const fadeInAnim = keyframes`
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
`;

export const Info = styled.div`
  height: 100%;
  width: 100%;
  font-family: ${fontFamilies.lato}, sans-serif;
  // overflow-y: auto;
  .arrows {
    opacity: 1;
    > path {
      opacity: 0;
      // stroke-dasharray: 300;
      stroke-dashoffset: 300;
      animation: ${arrowAnimation} 1s linear forwards;
    }
  }
  .arrow-1 {
    > path {
      animation-delay: 0s;
    }
  }
  .arrow-2 {
    > path {
      animation-delay: 0.5s;
    }
  }
  .arrow-3, .arrow-4, .arrow-5, .arrow-6 {
    > path {
      animation: ${arrowAnimation} 0.5s linear forwards;
      animation-delay: 1s;
    }
  }
  /*.arrow-4 {
    > path {
      animation-delay: 1.5s;
    }
  }
  .arrow-5 {
    > path {
      animation-delay: 2s;
    }
  }
  .arrow-6 {
    > path {
      animation-delay: 2.5s;
    }
  }*/
  .approval-status {
    font-size: ${fontSizes.small};
    padding: 8px 0;
  }
  .chart-wrapper {
    width: fit-content;
    margin-block: 24px;
    padding: 24px;
    background: ${colors.snowy_white};
    border-radius: 24px;
  }
  h4 {
    font-size: ${fontSizes.large};
    font-weight: 600;
    text-transform: uppercase;
    ${applyEllipsis(2)}
  }
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 980px) {
    width: 100%;
    .title-container {
      p {
        font-size: ${fontSizes.responsive.small};
      }
    }
  }
`;

export const IconWrapper = styled.div`
  height: ${props => (props.size ? props.size + 'px' : '30px')};
  width: ${props => (props.size ? props.size + 'px' : '30px')};
  background: ${props => (props.background ? props.background : colors.sunflower_yellow)};
  border-radius: 17.5px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  ${props =>
    props.absolute &&
    `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    `};
  ${props => props.bottom && `
    top: auto;
    bottom: -10%;
  `}
`;

export const JobCardsLayout = styled.div`
  padding: 24px;
  display: grid;
  align-items: start;
  justify-content: start;
  gap: 60px 100px;
  overflow: auto;
  height: 100%;
  scrollbar-width: none;
`;

export const ScrollableContainer = styled.div`
  height: calc(100% - 40px);
  overflow: auto;
  padding-bottom: 20px;

  > div {
    height: 100%;
  }
`;

const cardAnimation = keyframes`
  0% {
    opacity: 0;
    // transform: scale(0.7);
  }
/*  75% {
    transform: scale(1.2);
  }*/
  100% {
    opacity: 1;
    // transform: scale(1);
  }
`;

export const JobCard = styled.div`
  position: ${props => props.relative && 'relative'};
  width: ${props => (props.width ? props.width : 180)}px;
  background: ${colors.white};
  padding: 20px;
  border-radius: 18px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  grid-column: ${props => props.position.column};
  grid-row: ${props => props.position.row};
  // transform: scale(0);
  opacity: 0;
  // transform-origin: 0 50%;
  animation: ${cardAnimation} 0.8s forwards;
  animation-delay: ${props => `${props.index < 2 ? props.index * 0.5 : ((props.index - 1) * 0.1) + 0.5}s`};
  :hover {
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    -webkit-transition: box-shadow 0.6s ease-in;
  }  
    transition: box-shadow 0.6s ease-in-out;
    -webkit-transition: box-shadow 0.6s ease-in-out;
`;

export const JobTitle = styled.div`
  background: ${colors.black};
  color: ${colors.white};
  text-align: center;
  text-transform: uppercase;
  padding: 8px 4px;
  font-size: ${fontSizes.small};
  @media (max-width: 980px) {
    font-size: ${fontSizes.responsive.medium};
  }
`;

export const JobCardContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 18px;
  padding: 18px 4px 0 4px;
  .card-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .card {
    background: #fff;
    border-radius: 16px;
    padding: 8px 12px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 200px;
    position: relative;
  }
  .card-outlined .avatar {
    width: 54px; height: 54px;
    border-radius: 50%;
    background: #e6f4ff;
    display: flex; align-items: center; justify-content: center;
    outline: 4px solid #bae0ff;
    outline-offset: 3px;
  }
  .card-outlined .avatar svg { width: 36px; height: 36px; fill: #1677ff; }
  .card-outlined .badge {
    background: #1677ff;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.8px;
    padding: 2px 10px;
    border-radius: 20px;
    text-transform: uppercase;
    margin-top: 2px;
  }
  .card-outlined .name {
    font-size: 16px; font-weight: 700; color: #262626;
  }
`;

export const JobCount = styled.h1`
  font-size: ${fontSizes.extra_large};
  font-weight: 500;
  text-align: center;
  font-family: ${fontFamilies.oswald}, sans-serif;
  @media (max-width: 980px) {
    font-size: ${fontSizes.responsive.extra_large};
  }
`;

export const PrinterAndTickIcon = styled.div`
  position: relative;
  div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const JobCardContentText = styled.p`
  color: ${colors.black};
  text-align: center;
  @media (max-width: 980px) {
    font-size: ${fontSizes.small};
  }
`;

const stepsAnimation = keyframes`
  0% {
    stroke-dashoffset: 8.5;
  }
  100% {
    stroke-dashoffset: 0;
  }
`;

const levelTextAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const StepContainer = styled.div`
  .steps {
    line {
      stroke: #d8d6d8;
      // stroke: black;
      &.animate {
        stroke: #9c179e;
        stroke-dasharray: 8.5;
        stroke-dashoffset: 8.5;
        animation: ${stepsAnimation} 1s forwards;
      }
    }
    line.animate.delay {
       animation-delay: 1s;
    }
    text {
      font-size: 3px;
      opacity: 0;
      animation: ${levelTextAnimation} 1s forwards;
    }
    image {
      opacity: 0;
      animation: ${levelTextAnimation} 1s forwards;
    }
  }
`;

export const Step = styled.div`
  position: relative;
  height: ${props => !props.isLastStep && props.size}px;
  width: ${props => props.size}px;
  border-right: ${props => !props.isLastStep && props.strokeWidth}px solid;
  border-bottom: ${props => props.strokeWidth}px solid;
  border-color: ${props => props.isCompleted && props.primaryColor};
  margin-left: ${props => (props.stepId - 1) * props.size}px;
  div {
    position: absolute;
    right: ${props => props.strokeWidth}px;
    bottom: ${props => props.strokeWidth}px;
    display: flex;
    gap: 2px;
    align-items: center;
    justify-content: flex-end;
    p {
      color: ${colors.black};
      font-size: ${fontSizes.small};
      font-weight: 700;
      white-space: nowrap;
    }
  }
`;

export const JobInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const JobInfoTile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  .channel-name {
    font-size: ${fontSizes.small};
  }
  h3 {
    font-size: ${fontSizes.large};
    font-weight: 500;
    font-family: ${fontFamilies.oswald}, sans-serif;
  }
  .channel-icon {
    background: ${colors.olive_green};
    border-radius: 8px;
    height: 32px;
    width: 32px;
    display: grid;
    place-content: center;
  }
  .job-status {
    font-size: ${fontSizes.extra_small};
    color: ${colors.black};
    font-weight: 700;
    text-transform: uppercase;
  }
`;

const slideIn = keyframes`
  0% {
    left: -10%;
    opacity: 0;
  }
  75% {
    left: 1%;
    opacity: 0;
  }
  100% {
    left: 0;
    opacity: 1;
  }
`;

export const StatusFilters = styled(Filters)`
  gap: 12px !important;
  .hide_button {
    font-size: 14px;
    font-weight: 500;
    color: #adadad;
    cursor: pointer;
  }
  .label {
    margin-bottom: 3px;
  }
  .ant-col {
    animation: ${slideIn} 0.4s ease-in;
  }
`;

export const BatchCurrentStatus = styled.div`
  background: ${props => props.bg ? props.bg : '#fcf7f6'};
  color: ${props => statusTextColor.includes(props.status) ? colors.white : colors.black};
  width: fit-content;
  padding: 4px 12px;
  font-size: ${fontSizes.extra_small};
  font-weight: 700;
  text-transform: uppercase;
  border-radius: 5px;
`;

export const NoRecord = styled.div`
  background: white;
  border-radius: 24px;
  width: 100%;
  height: 100%;
`;

export const NoApproverContent = styled.div`
  text-align: center;
  .ant-alert-warning {
    width: fit-content;
    margin-inline: auto;
    padding: 8px 8px 8px 24px;
    transform: scale(0);
    animation: ${popInAnim} 0.5s ease forwards;
  }
  .ant-alert-icon {
    top: 12.5px;
    left: 6px;
  }
  .ant-alert-message {
    font-size: 13px;
  }
  .description {
    font-size: 13px;
    line-height: 1.3;
    font-family: Lato;
    color: #000;
    text-align: center;
    padding: 12px 8px;
    opacity: 0;
    transform: translateY(100%);
    animation: ${fadeInAnim} 0.5s 0.2s ease forwards;
  }
  .buttons {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;
  }
  .ant-btn, .ant-btn:hover, .ant-btn:focus {
    padding: 2px 8px;
    border: none;
    box-shadow: rgb(38, 57, 77) 0px 4px 8px -5px;
    font-size: 13px;
    text-transform: uppercase;
    font-weight: bold;
    font-family: Lato !important;
    background: darkslategray;
    color: #f1f1f1;
    will-change: transform;
    opacity: 0;
    transform: translateY(100%);
  }
  .ant-btn:hover {
    transform: scale(1.05);
  }
  .primary, .primary:hover, .primary:focus {
    background: yellow;
    color: #333;
  }
  .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) {
    padding-left: 22px;
  }
  .ant-btn:nth-child(1) {
    animation: ${fadeInAnim} 0.5s 0.4s ease forwards;
  }
  .ant-btn:nth-child(2) {
    animation: ${fadeInAnim} 0.5s 0.6s ease forwards;
  }
`;

export const EmailViewContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  margin-left: 5%;
  padding: 2%;
  background-color: #e9e9e9;
  overflow-y: auto;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`

export const EmailErrorView = styled.div`
  width: 600px;
  text-align: center;
  margin: 20vh auto;
  background-color: #ffffff;
  h3 {
    font-weight: 600;
  }
  h5 {
    color: #6a6a6a;
    margin-top: 20px;
  }
`

export const ModalBody = styled.div`
  height: 80vh;
  overflow: auto;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  -moz-scrollbar-width: none;
  -ms-scrollbar-width: none;
  scrollbar-width: none;
  canvas{
    width: 100% !important;
  }
`

export const EmailCard = styled.div`
  .ant-modal .ant-modal-content {
    height: 100%;
    overflow: auto;
  }
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  height: 100%;
  min-height: 600px;
  width: 95%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  -moz-scrollbar-width: none;
  -ms-scrollbar-width: none;
  scrollbar-width: none;
`;

export const CardHeader = styled.div`
  padding: 10px 24px;
  background: #ffffff;
  border-bottom: 1px solid #e8e8e8;
`;

export const SubjectHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const SubjectTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  color: #262626;
  flex: 1;
  word-break: break-word;

  @media (max-width: 768px) {
    font-size: 20px;
    width: 100%;
  }
`;

export const Icon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => props.size || '14px'};
`;

export const MetaSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const SenderInfo = styled.span`
  color: #262626;
  font-weight: 600;
`;

export const TimeStamp = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #8c8c8c;
  font-size: 14px;
`;

export const ToggleButton = styled.button`
  width: 100%;
  padding: 8px 16px;
  margin-top: 8px;
  background: #ffffff;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  color: #595959;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s;

  &:hover {
    color: #1890ff;
    border-color: #1890ff;
  }
`;

export const RecipientSection = styled.div`
  padding: 8px 24px;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
`;

export const RecipientRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const RecipientLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 80px;
  color: #595959;
  font-weight: 500;
  font-size: 14px;

  @media (max-width: 768px) {
    min-width: auto;
  }
`;

export const RecipientList = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  height 45px;
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  -moz-scrollbar-width: none;
  -ms-scrollbar-width: none;
  scrollbar-width: none;
`;

export const EmailTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: ${props => props.color === 'green' ? '#f6ffed' : '#fff7e6'};
  color: ${props => props.color === 'green' ? '#52c41a' : '#fa8c16'};
  border: 1px solid ${props => props.color === 'green' ? '#b7eb8f' : '#ffd591'};
  border-radius: 16px;
  font-size: 13px;
`;

export const Avatar = styled.div`
  width: ${props => props.size === 'small' ? '20px' : '32px'};
  height: ${props => props.size === 'small' ? '20px' : '32px'};
  border-radius: 50%;
  background: ${props => props.bg || '#1890ff'};
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => props.size === 'small' ? '10px' : '14px'};
  font-weight: 500;
`;

export const EmailBody = styled.div`
  padding: 10px 24px;
  background: #ffffff;
  width: 80%;
  flex: 1;
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  -moz-scrollbar-width: none;
  -ms-scrollbar-width: none;
  scrollbar-width: none;
  
  iframe {
    width: 100%;
    height: 100%;
    border: none;
    overflow: auto;
    ::-webkit-scrollbar {
      display: none;
    }
    -moz-scrollbar-width: none;
    -ms-scrollbar-width: none;
    scrollbar-width: none;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px;
  gap: 16px;
`;

export const AttachmentsSection = styled.div`
  padding: 12px;
  background: #fafafa;
  border-top: 1px solid #e8e8e8;
  flex-shrink: 0;
  width: 20%;
  min-width: 250px;
  height: 100%;
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  -moz-scrollbar-width: none;
  -ms-scrollbar-width: none;
  scrollbar-width: none;
`;

export const AttachmentsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 15px;
  color: #262626;
`;

export const AttachmentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AttachmentCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 16px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.5 : 1};

  &:hover {
    border-color: ${props => props.disabled ? '#d9d9d9' : '#1890ff'};
    box-shadow: ${props => props.disabled ? 'none' : '0 2px 8px rgba(24, 144, 255, 0.2)'};

    .download-btn {
      opacity: 1;
    }
  }
`;

export const FileIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: ${props => props.disabled ? 'linear-gradient(135deg, #8c8c8c 0%, #595959 100%)' : 'linear-gradient(135deg, #ff4d4f 0%, #cf1322 100%)'};
  border-radius: 6px;
  flex-shrink: 0;
  color: #ffffff;
  font-size: 20px;
`;

export const FileInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FileName = styled.div`
  font-weight: 500;
  color: #262626;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FileType = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 2px;
`;

export const DownloadButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #1890ff;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 14px;

  &:hover {
    background: #40a9ff;
  }
`;

export const ApprovalButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid;
  transition: all 0.2s ease;
  cursor: pointer;

  background: ${({ active }) => (active ? '#ede9fe' : '#f3f4f6')};
  color: ${({ active }) => (active ? '#6d28d9' : '#4b5563')};
  border-color: ${({ active }) => (active ? '#c4b5fd' : '#e5e7eb')};

  &:hover {
    background: ${({ active }) => (active ? '#ede9fe' : '#e5e7eb')};
  }

  div {
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease, border-color 0.2s ease;

    background: ${({ active }) => (active ? '#7c3aed' : '#ffffff')};
    border: ${({ active }) => (active ? 'none' : '1px solid #d1d5db')};

    svg path {
      fill: #fff;
    }
  }
`;

export const MoreButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #e5e7eb;
  }
`;

export const ChevronIcon = styled.span`
  display: flex;
  transition: transform 0.2s ease;
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
`;
